import React from 'react'
import ReactDOM from 'react-dom'
import { Components } from '@src/containers/ElamaIndex'

const modalButtons = document.querySelectorAll('.index-modal-button')

modalButtons.forEach(modalButton => {
  const variant = modalButton.getAttribute('data-variant') || 'edtech'
  const elementId = modalButton.getAttribute('data-elementId') || 'edtech-form'
  const renderPlace = modalButton.getAttribute('data-renderPlace') || 'form'
  ReactDOM.render(
    <Components.ModalButton variant={variant} renderPlace={renderPlace} elementId={elementId} />,
    modalButton
  )
})
